module.exports = __webpack_public_path__ + "img/card-reincarare.5153583a.svg";